import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'coverage',
    loadChildren: () =>
      import('./features/coverage/coverage.module').then(
        m => m.CoverageModule
      )
  },
  {
    path: 'coverage-results',
    loadChildren: () =>
      import('./features/coverage-results/coverage-results.module').then(
        m => m.CoverageResultsModule
      )
  },
  {
    path: 'reviews',
    loadChildren: () =>
      import('./features/reviews/reviews.module').then(
        m => m.ReviewsModule
      )
  },
  {
    path: 'desktop-app',
    loadChildren: () =>
      import('./features/desktop-app/desktop-app-widget.module').then(
        m => m.DesktopAppWidgetModule
      )
  },
  {
    path: 'callback-widget',
    loadChildren: () => 
      import('./features/callback-widget/callback-widget.module').then(
        m => m.CallbackWidgetModule
      )
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
